import React, { useState, useRef, useEffect } from "react";
import styles from "./SearchInputWithDropdown.module.css";
import search_icon from "../../../assets/images/search_icon.svg";
import dropdown_icon from "../../../assets/images/dropdown_icon.svg";

const SearchInputWithDropdown = ({
  options = [],
  selectedOption,
  onOptionChange,
  searchValue,
  onSearchChange,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);

  // Find the selected option object
  const selectedOptionObj =
    options.find((opt) => opt.value === selectedOption) || options[0];

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleOptionSelect = (optionValue) => {
    onOptionChange(optionValue);
    setIsDropdownOpen(false);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className={styles.searchContainer} ref={wrapperRef}>
      {/* Dropdown Section */}
      <div className={styles.dropdownSection}>
        <button
          type="button"
          className={styles.dropdownButton}
          onClick={handleDropdownToggle}
          aria-expanded={isDropdownOpen}
          aria-haspopup="listbox"
        >
          <span className={styles.dropdownLabel}>
            {selectedOptionObj?.label || "Select"}
          </span>
          <span
            className={`${styles.dropdownArrow} ${
              isDropdownOpen ? styles.open : ""
            }`}
          >
            <img src={dropdown_icon} alt="dropdown" />
          </span>
        </button>
        {isDropdownOpen && (
          <div className={styles.dropdownMenu} ref={dropdownRef} role="listbox">
            {options.map((option) => (
              <div
                key={option.value}
                className={`${styles.dropdownOption} ${
                  selectedOption === option.value ? styles.selected : ""
                }`}
                onClick={() => handleOptionSelect(option.value)}
                role="option"
                aria-selected={selectedOption === option.value}
              >
                {option.label}
                {selectedOption === option.value && (
                  <span className={styles.checkmark} aria-hidden="true" />
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Divider */}
      <div className={styles.divider}></div>

      {/* Input Section */}
      <div className={styles.inputSection}>
        <img src={search_icon} alt="Search" className={styles.searchIcon} />
        <input
          type="text"
          className={styles.searchInput}
          placeholder={selectedOptionObj?.placeholder || "Search..."}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchInputWithDropdown;
